(() => {

  'use strict';

  if (window.__skOptBuyBoxLoaded) return;

  window.__skOptBuyBoxLoaded = true;

  const ROOT = '[data-sk-opt]';

  const CARD = '[data-sk-opt-offer]';

  const RESUME_PARAM = '_sk_opt_resume';

  const RESUME_PREFIX = 'sk-opt-resume:';

  const productCache = new Map();

  const shopRoot = () => window.Shopify?.routes?.root || '/';

  const shopRoute = (path) => `${shopRoot().replace(/\/?$/, '/')}${String(path).replace(/^\/+/, '')}`;

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const int = (value, fallback = 0) => Number.isFinite(Number(value)) ? Math.max(0, Math.floor(Number(value))) : fallback;

  const text = (value) => String(value || '').trim();

  function parseConfig(root) {

    try {

      return JSON.parse(root.querySelector('[data-sk-opt-flavor-config]')?.textContent || '{}');

    } catch (error) {

      console.warn('SK OPT: invalid flavor configuration', error);

      return { flavors: [] };

    }

  }

  function getFlavors(root) {

    return (parseConfig(root).flavors || []).map((flavor) => ({

      id: text(flavor.variantId),

      label: text(flavor.label),

      image: text(flavor.imageSrc),

      available: true

    })).filter((flavor) => flavor.id && flavor.label && /^\d+$/.test(flavor.id));

  }

  function setStatus(card, message) {

    const target = card.querySelector('[data-sk-opt-status]');

    if (target) target.textContent = message || '';

  }

  function setBusy(card, busy) {

    const button = card.querySelector('[data-sk-opt-checkout]');

    if (!button) return;

    button.disabled = busy;

    if (!button.dataset.defaultText) button.dataset.defaultText = button.textContent;

    button.textContent = busy ? 'Preparing your checkout…' : button.dataset.defaultText;

    if (!busy) updateFlavorUI(card);

  }

  function setupGallery(root) {

    const main = root.querySelector('[data-sk-opt-main-image]');

    const media = root.querySelector('[data-sk-opt-main-media]');

    const thumbs = root.querySelector('[data-sk-opt-thumbs]');

    const prev = root.querySelector('[data-sk-opt-prev]');

    const next = root.querySelector('[data-sk-opt-next]');

    if (!main || !media || !thumbs) return { useGroup() {} };

    const groups = new Map();

    root.querySelectorAll('[data-sk-opt-gallery-entry]').forEach((item) => {

      const offers = (item.dataset.offers || '').split(',').filter((slot) => /^[1-5]$/.test(slot));

      offers.forEach((slot) => {

        const group = `offer_${slot}`;

        if (!groups.has(group)) groups.set(group, []);

        if (groups.get(group).length < 13) groups.get(group).push({

          src: item.dataset.full,

          thumb: item.dataset.thumb,

          alt: item.dataset.alt || ''

        });

      });

    });

    let slides = [];

    let active = 0;

    let requestId = 0;

    function controls() {

      prev.hidden = next.hidden = slides.length < 2;

      prev.disabled = active === 0;

      next.disabled = active >= slides.length - 1;

    }

    function swap(index, animate = true) {

      if (index < 0 || index >= slides.length) return;

      active = index;

      controls();

      const buttons = Array.from(thumbs.querySelectorAll('[data-sk-opt-thumb]'));

      buttons.forEach((button, i) => {

        const selected = i === index;

        button.classList.toggle('is-active', selected);

        button.setAttribute('aria-current', selected ? 'true' : 'false');

      });

      if (buttons[index]) {

        const button = buttons[index];

        const left = button.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - button.offsetWidth) / 2;

        thumbs.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });

      }

      const slide = slides[index];

      const current = ++requestId;

      const preload = new Image();

      preload.onload = () => {

        if (current !== requestId) return;

        media.querySelector('.sk-opt__transition')?.remove();

        const outgoing = animate && !main.hidden && main.getAttribute('src') ? main.cloneNode(false) : null;

        if (outgoing) {

          outgoing.className = 'sk-opt__transition';

          outgoing.removeAttribute('data-sk-opt-main-image');

          outgoing.setAttribute('aria-hidden', 'true');

          outgoing.alt = '';

          media.appendChild(outgoing);

        }

        main.hidden = false;

        main.src = slide.src;

        main.alt = slide.alt;

        media.querySelector('.sk-opt__placeholder')?.remove();

        if (outgoing) {

          requestAnimationFrame(() => requestAnimationFrame(() => outgoing.classList.add('is-fading')));

          outgoing.addEventListener('transitionend', () => outgoing.remove(), { once: true });

          setTimeout(() => outgoing.remove(), 280);

        }

      };

      preload.src = slide.src;

    }

    function useGroup(group) {

      slides = groups.get(`offer_${group}`) || [];

      thumbs.replaceChildren();

      if (!slides.length) {

        requestId++;

        media.querySelector('.sk-opt__transition')?.remove();

        main.hidden = true;

        if (!media.querySelector('.sk-opt__placeholder')) {

          const placeholder = document.createElement('span');

          placeholder.className = 'sk-opt__placeholder';

          media.appendChild(placeholder);

        }

        active = 0;

        controls();

        return;

      }

      slides.forEach((slide, index) => {

        const button = document.createElement('button');

        button.type = 'button';

        button.className = 'sk-opt__thumb';

        button.dataset.skOptThumb = '';

        button.setAttribute('aria-label', `View product image ${index + 1}`);

        const image = document.createElement('img');

        image.src = slide.thumb;

        image.alt = slide.alt;

        image.loading = 'lazy';

        button.appendChild(image);

        button.addEventListener('click', () => swap(index));

        thumbs.appendChild(button);

        const preload = new Image();

        preload.src = slide.src;

      });

      active = 0;

      if (slides.length) swap(0, false);

      controls();

    }

    prev.addEventListener('click', () => swap(active - 1));

    next.addEventListener('click', () => swap(active + 1));

    let touchStart = null;

    media.addEventListener('touchstart', (event) => {

      if (event.touches.length === 1 && matchMedia('(max-width: 749px)').matches) {

        touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };

      }

    }, { passive: true });

    media.addEventListener('touchend', (event) => {

      if (!touchStart || !event.changedTouches.length) return;

      const dx = event.changedTouches[0].clientX - touchStart.x;

      const dy = event.changedTouches[0].clientY - touchStart.y;

      touchStart = null;

      if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.2) swap(active + (dx < 0 ? 1 : -1));

    }, { passive: true });

    media.addEventListener('touchcancel', () => { touchStart = null; });

    return { useGroup };

  }

  function total(card) {

    return Object.values(card.__skOptCounts || {}).reduce((a, b) => a + b, 0);

  }

  function updateFlavorUI(card) {
    const capacity = int(card.dataset.skOptQuantity, 1) || 1;
    const counts = card.__skOptCounts || {};
    const styleTwo = card.closest(ROOT)?.dataset.skOptFlavorStyle === 'style_2';
    const picked = total(card);
    card.querySelectorAll('[data-sk-opt-flavor]').forEach((button) => {
      const qty = counts[button.dataset.variant] || 0;
      button.classList.toggle('is-picked', qty > 0);
      if (styleTwo) {
        const cell = button.closest('.sk-opt__flavor-cell');
        const stepper = cell?.querySelector('[data-sk-opt-stepper]');
        cell?.classList.toggle('is-picked', qty > 0);
        if (stepper) stepper.hidden = qty === 0;
        const count = stepper?.querySelector('[data-sk-opt-inline-count]');
        if (count) count.textContent = String(qty);
        const plus = stepper?.querySelector('[data-sk-opt-add]');
        if (plus) plus.disabled = picked >= capacity;
        button.setAttribute('aria-label', `${button.dataset.flavorLabel}, ${qty} selected. Tap to add one`);
      } else {
        button.querySelector('[data-sk-opt-count]')?.remove();
        if (qty) {
          const badge = document.createElement('span');
          badge.className = 'sk-opt__flavor-count';
          badge.dataset.skOptCount = '';
          badge.textContent = String(qty);
          button.appendChild(badge);
        }
        button.setAttribute('aria-label', `${button.dataset.flavorLabel}, ${qty} of ${capacity} selected. Tap to add`);
      }
    });
    const remaining = capacity - picked;
    const footer = card.querySelector('[data-sk-opt-progress]');
    if (footer) footer.textContent = `${picked} of ${capacity} ${capacity === 1 ? 'bag' : 'bags'} selected`;
    const checkoutButton = card.querySelector('[data-sk-opt-checkout]');
    if (checkoutButton && !card.__skOptBusy) {
      if (!checkoutButton.dataset.defaultText) checkoutButton.dataset.defaultText = checkoutButton.textContent;
      checkoutButton.textContent = picked > 0 && remaining > 0 ? `Select ${remaining} More ${remaining === 1 ? 'Flavor' : 'Flavors'}` : checkoutButton.dataset.defaultText;
    }
    const reset = card.querySelector('[data-sk-opt-reset]');
    if (reset) reset.hidden = picked === 0;
    if (!styleTwo) {
      card.querySelectorAll('[data-sk-opt-remove]').forEach((node) => node.remove());
      card.querySelectorAll('[data-sk-opt-flavor]').forEach((button) => {
        const qty = counts[button.dataset.variant] || 0;
        if (!qty) return;
        const minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'sk-opt__flavor-remove';
        minus.dataset.skOptRemove = button.dataset.variant;
        minus.textContent = '−';
        minus.setAttribute('aria-label', `Remove one ${button.dataset.flavorLabel}`);
        button.after(minus);
      });
    }
  }

  function renderFlavors(root, card, flavors) {
    const wrap = card.querySelector('[data-sk-opt-flavors]');
    if (!wrap) return;
    const capacity = int(card.dataset.skOptQuantity, 1) || 1;
    const styleTwo = root.dataset.skOptFlavorStyle === 'style_2';
    card.__skOptCounts = card.__skOptCounts || {};
    wrap.replaceChildren();
    flavors.forEach((flavor) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sk-opt__flavor';
      button.dataset.skOptFlavor = '';
      button.dataset.variant = flavor.id;
      button.dataset.flavorLabel = flavor.label;
      button.disabled = !flavor.available;
      if (!flavor.available) button.classList.add('is-unavailable');
      if (flavor.image) {
        const image = document.createElement('img');
        image.src = flavor.image;
        image.alt = '';
        image.loading = 'lazy';
        button.appendChild(image);
      } else {
        const fallback = document.createElement('span');
        fallback.className = 'sk-opt__flavor-fallback';
        fallback.textContent = flavor.label[0].toUpperCase();
        button.appendChild(fallback);
      }
      const label = document.createElement('span');
      label.textContent = flavor.label + (!flavor.available ? ' (Sold out)' : '');
      button.appendChild(label);
      button.addEventListener('click', () => {
        const count = card.__skOptCounts[flavor.id] || 0;
        if (total(card) >= capacity) {
          if (!styleTwo && count > 0) card.__skOptCounts[flavor.id] = count - 1;
          else setStatus(card, `You've selected all ${capacity} bags. Remove one to switch flavors.`);
        } else {
          card.__skOptCounts[flavor.id] = count + 1;
          setStatus(card, '');
        }
        updateFlavorUI(card);
      });
      const cell = document.createElement('span');
      cell.className = 'sk-opt__flavor-cell';
      cell.appendChild(button);
      if (styleTwo && flavor.available) {
        const stepper = document.createElement('span');
        stepper.className = 'sk-opt__flavor-stepper';
        stepper.dataset.skOptStepper = '';
        stepper.hidden = true;
        const minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'sk-opt__stepper-button sk-opt__stepper-minus';
        minus.dataset.skOptRemove = flavor.id;
        minus.setAttribute('aria-label', `Remove one ${flavor.label}`);
        const number = document.createElement('span');
        number.className = 'sk-opt__stepper-count';
        number.dataset.skOptInlineCount = '';
        number.textContent = '0';
        const plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'sk-opt__stepper-button sk-opt__stepper-plus';
        plus.dataset.skOptAdd = flavor.id;
        plus.setAttribute('aria-label', `Add one ${flavor.label}`);
        stepper.append(minus, number, plus);
        cell.appendChild(stepper);
      }
      wrap.appendChild(cell);
    });
    if (!wrap.dataset.skOptHandlersBound) {
      wrap.dataset.skOptHandlersBound = 'true';
      wrap.addEventListener('click', (event) => {
        const minus = event.target.closest('[data-sk-opt-remove]');
        const plus = event.target.closest('[data-sk-opt-add]');
        if (!minus && !plus) return;
        const id = minus ? minus.dataset.skOptRemove : plus.dataset.skOptAdd;
        if (minus) {
          card.__skOptCounts[id] = Math.max(0, (card.__skOptCounts[id] || 0) - 1);
          setStatus(card, '');
        } else if (total(card) < capacity) {
          card.__skOptCounts[id] = (card.__skOptCounts[id] || 0) + 1;
          setStatus(card, '');
        } else {
          setStatus(card, `You've selected all ${capacity} bags. Remove one to switch flavors.`);
        }
        updateFlavorUI(card);
      });
      card.querySelector('[data-sk-opt-reset]')?.addEventListener('click', () => {
        card.__skOptCounts = {};
        setStatus(card, '');
        updateFlavorUI(card);
      });
    }
    if (card.dataset.skOptPreselect === 'true' && total(card) === 0) {
      const first = flavors.find((flavor) => flavor.available);
      if (first) card.__skOptCounts[first.id] = capacity;
    }
    updateFlavorUI(card);
  }

  async function loadProduct(handle, force = false) {

    if (!handle) return null;

    if (!force && productCache.has(handle)) return productCache.get(handle);

    const request = fetch(shopRoute(`products/${encodeURIComponent(handle)}.js`), {

      headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store'

    }).then((response) => {

      if (!response.ok) throw new Error(`Unable to check inventory (${response.status}).`);

      return response.json();

    });

    productCache.set(handle, request);

    try { return await request; }

    catch (error) { productCache.delete(handle); throw error; }

  }

  async function availability(root, force = false) {

    const product = await loadProduct(text(root.dataset.skOptProductHandle), force);

    const variants = product ? new Map(product.variants.map((v) => [String(v.id), v])) : null;

    const flavors = getFlavors(root);

    flavors.forEach((flavor) => {

      if (variants) flavor.available = Boolean(variants.get(flavor.id)?.available);

    });

    return flavors;

  }

  function normalizeParams(value) {

    const raw = text(value);

    if (!raw) return '';

    let query = raw;

    try { if (/^https?:\/\//i.test(raw)) query = new URL(raw).search; } catch (error) { /* not a URL */ }

    if (query.includes('?')) query = query.slice(query.indexOf('?') + 1);

    query = query.replace(/^[?&]+/, '').split('#')[0];

    return query;

  }

  function paramsFor(card) { return new URLSearchParams(normalizeParams(card.dataset.skOptBogo)); }

  function allBogoKeys(root) {

    const keys = new Set();

    root.querySelectorAll(CARD).forEach((card) => paramsFor(card).forEach((_, key) => {

      if (key && key !== RESUME_PARAM) keys.add(key);

    }));

    return keys;

  }

  function reloadIfNecessary(root, card) {

    const keys = allBogoKeys(root);

    if (!keys.size) return false;

    const desired = paramsFor(card);

    const current = new URL(location.href);

    if (![...keys].some((key) => current.searchParams.getAll(key).join(',') !== desired.getAll(key).join(','))) return false;

    const state = {

      sectionId: root.dataset.skOptSectionId,

      slot: card.dataset.skOptSlot,

      counts: card.__skOptCounts,

      scrollX: scrollX,

      scrollY: scrollY,

      time: Date.now()

    };

    const token = `${Date.now()}-${Math.random().toString(36).slice(2)}`;

    try { sessionStorage.setItem(RESUME_PREFIX + token, JSON.stringify(state)); }

    catch (error) { throw new Error('Browser session storage is required to reload BOGOS parameters.'); }

    keys.forEach((key) => current.searchParams.delete(key));

    desired.forEach((value, key) => { if (key !== RESUME_PARAM) current.searchParams.append(key, value); });

    current.searchParams.set(RESUME_PARAM, token);

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    location.replace(current.toString());

    return true;

  }

  function resumeState(root) {

    const url = new URL(location.href);

    const token = url.searchParams.get(RESUME_PARAM);

    if (!token) return null;

    const key = RESUME_PREFIX + token;

    let state;

    try {

      state = JSON.parse(sessionStorage.getItem(key) || 'null');

      if (state?.sectionId === root.dataset.skOptSectionId) {

        sessionStorage.removeItem(key);

        url.searchParams.delete(RESUME_PARAM);

        history.replaceState(history.state, '', url.pathname + url.search + url.hash);

      }

    } catch (error) { return null; }

    if (!state || Date.now() - state.time > 90000 || state.sectionId !== root.dataset.skOptSectionId) return null;

    return state;

  }

  async function jsonRequest(path, body) {

    const response = await fetch(shopRoute(path), {

      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },

      body: JSON.stringify(body), credentials: 'same-origin', cache: 'no-store'

    });

    const type = response.headers.get('content-type') || '';

    const value = type.includes('json') ? await response.json() : await response.text();

    if (!response.ok) throw new Error(value?.description || value?.message || (typeof value === 'string' ? value : `Cart error ${response.status}`));

    return value;

  }

  async function getCart() {

    const response = await fetch(shopRoute('cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });

    if (!response.ok) throw new Error('Unable to read your cart.');

    return response.json();

  }

  async function waitForGift(baseline) {

    const deadline = Date.now() + 6000;

    while (Date.now() < deadline) {

      await sleep(240);

      try { if ((await getCart()).item_count > baseline) return true; }

      catch (error) { return false; }

    }

    return false;

  }

  function checkoutUrl(card) {

    const url = new URL(shopRoute('checkout'), location.origin);

    const allKeys = allBogoKeys(card.closest(ROOT));

    new URLSearchParams(location.search).forEach((value, key) => {

      if (key !== RESUME_PARAM && key !== 'discount' && !allKeys.has(key)) url.searchParams.append(key, value);

    });

    paramsFor(card).forEach((value, key) => { if (key !== RESUME_PARAM) url.searchParams.append(key, value); });

    const discounts = text(card.dataset.skOptDiscounts).split(/[\n,]+/).map((v) => v.trim()).filter(Boolean);

    if (discounts.length) url.searchParams.set('discount', discounts.join(','));

    return url.pathname + url.search + url.hash;

  }

  async function checkout(root, card, skipReload = false) {

    if (card.__skOptBusy) return;

    const capacity = int(card.dataset.skOptQuantity, 1) || 1;

    if (total(card) !== capacity) {

      setStatus(card, `Please choose exactly ${capacity} ${capacity === 1 ? 'bag' : 'bags'} before checkout.`);

      return;

    }

    card.__skOptBusy = true;

    setBusy(card, true);

    setStatus(card, '');

    try {

      const flavors = await availability(root, true);

      const allowed = new Set(flavors.filter((f) => f.available).map((f) => f.id));

      const selected = Object.entries(card.__skOptCounts).filter(([, qty]) => qty > 0);

      if (selected.some(([id]) => !allowed.has(id))) throw new Error('A selected flavor is sold out. Please choose another.');

      if (selected.length === 0) throw new Error('Please choose your flavors.');

      if (!skipReload && reloadIfNecessary(root, card)) return;

      const sellingPlan = text(card.dataset.skOptSellingPlan);

      if (sellingPlan && !/^\d+$/.test(sellingPlan)) throw new Error('Invalid selling plan ID in Theme Editor.');

      const extraIds = text(card.dataset.skOptAdditionalVariants).split(/[\s,;|]+/).filter(Boolean);

      const itemsByKey = new Map();

      selected.forEach(([id, qty]) => {

        const key = `${id}::${sellingPlan}`;

        itemsByKey.set(key, { id: Number(id), quantity: qty, ...(sellingPlan ? { selling_plan: Number(sellingPlan) } : {}) });

      });

      extraIds.forEach((entry) => {

        const match = entry.match(/^(\d+)(?::(\d+))?$/);

        const id = match ? Number(match[1]) : 0;

        const qty = match ? Number(match[2] || 1) : 0;

        if (!Number.isSafeInteger(id) || id < 1 || !Number.isSafeInteger(qty) || qty < 1) {

          throw new Error('Invalid additional variant ID. Use Shopify variant IDs, optionally followed by :quantity.');

        }

        const key = `${id}::`;

        const existing = itemsByKey.get(key);

        if (existing) existing.quantity += qty;

        else itemsByKey.set(key, { id, quantity: qty });

      });

      const items = [...itemsByKey.values()];

      const clearCart = card.dataset.skOptClearCart === 'true';

      if (!paramsFor(card).toString()) {

        const addParams = new URLSearchParams();

        items.forEach((item, index) => {

          addParams.set(`items[${index}][id]`, String(item.id));

          addParams.set(`items[${index}][quantity]`, String(item.quantity));

          if (item.selling_plan) addParams.set(`items[${index}][selling_plan]`, String(item.selling_plan));

        });

        addParams.set('return_to', checkoutUrl(card));

        const addUrl = `${shopRoute('cart/add')}?${addParams.toString()}`;

        location.assign(clearCart ? `${shopRoute('cart/clear')}?return_to=${encodeURIComponent(addUrl)}` : addUrl);

        return;

      }

      if (clearCart) { await jsonRequest('cart/clear.js', {}); await sleep(150); }

      const before = await getCart();

      await jsonRequest('cart/add.js', { items });

      const after = await getCart();

      const attrs = {};

      const selectedParams = paramsFor(card);

      allBogoKeys(root).forEach((key) => { attrs[key] = selectedParams.get(key) ?? ''; });

      if (Object.keys(attrs).length) {

        const updated = await jsonRequest('cart/update.js', { attributes: attrs });

        const actual = updated?.item_count ?? after.item_count;

        const expectedCount = before.item_count + items.reduce((sum, item) => sum + item.quantity, 0);

        if (actual <= expectedCount) await waitForGift(actual);

      }

      location.assign(checkoutUrl(card));

    } catch (error) {

      setStatus(card, error?.message || 'Checkout failed. Please try again.');

      card.__skOptBusy = false;

      setBusy(card, false);

      try {

        const flavors = await availability(root, true);

        root.querySelectorAll(CARD).forEach((offer) => {

          const counts = offer.__skOptCounts || {};

          renderFlavors(root, offer, flavors);

          offer.__skOptCounts = counts;

          updateFlavorUI(offer);

        });

      } catch (ignored) { /* retain current UI */ }

    }

  }

  function initRoot(root) {

    if (root.dataset.skOptInitialized === 'true') return;

    root.dataset.skOptInitialized = 'true';

    const cards = Array.from(root.querySelectorAll(CARD)).slice(0, 5);

    if (!cards.length) return;

    const gallery = setupGallery(root);

    const state = resumeState(root);

    let active = cards[0];

    function select(card) {

      active = card;

      cards.forEach((item) => {

        const selected = item === card;

        item.classList.toggle('is-active', selected);

        item.querySelector('[data-sk-opt-select]')?.setAttribute('aria-expanded', String(selected));

      });

      gallery.useGroup(card.dataset.skOptSlot);

    }

    cards.forEach((card) => {

      card.__skOptCounts = {};

      card.querySelector('[data-sk-opt-select]')?.addEventListener('click', () => select(card));

      card.querySelector('[data-sk-opt-checkout]')?.addEventListener('click', () => checkout(root, card));

    });

    select(active);

    const membershipJump = root.querySelector('[data-sk-opt-membership-jump]');

    membershipJump?.addEventListener('click', (event) => {

      const target = cards.find((card) => card.dataset.skOptSlot === membershipJump.dataset.skOptMembershipJump);

      if (!target) return;

      event.preventDefault();

      select(target);

      requestAnimationFrame(() => target.scrollIntoView({

        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',

        block: 'start'

      }));

    });

    const nutritionTrigger = root.querySelector('[data-sk-opt-nutrition-trigger]');

    const nutritionDialog = root.querySelector('[data-sk-opt-nutrition-dialog]');

    if (nutritionTrigger && nutritionDialog) {

      nutritionTrigger.addEventListener('click', () => nutritionDialog.showModal());

      nutritionDialog.querySelector('[data-sk-opt-nutrition-close]')?.addEventListener('click', () => nutritionDialog.close());

      nutritionDialog.addEventListener('click', (event) => {

        if (event.target !== nutritionDialog) return;

        const bounds = nutritionDialog.getBoundingClientRect();

        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) nutritionDialog.close();

      });

    }

    availability(root).then((flavors) => {

      cards.forEach((card) => {

        renderFlavors(root, card, flavors);

        if (!flavors.length) setStatus(card, 'Add flavor variant IDs in the Theme Editor to enable checkout.');

      });

      if (state && flavors.length) {

        const resumed = cards.find((card) => card.dataset.skOptSlot === state.slot);

        if (resumed) {

          select(resumed);

          const capacity = int(resumed.dataset.skOptQuantity, 1) || 1;

          const allowed = new Set(flavors.filter((f) => f.available).map((f) => f.id));

          const counts = {};

          Object.entries(state.counts || {}).forEach(([id, qty]) => {

            if (allowed.has(id)) counts[id] = Math.min(capacity, int(qty));

          });

          resumed.__skOptCounts = counts;

          updateFlavorUI(resumed);

          const restore = () => scrollTo({ left: state.scrollX || 0, top: state.scrollY || 0, behavior: 'instant' });

          restore();

          requestAnimationFrame(restore);

          setTimeout(restore, 120);

          checkout(root, resumed, true);

        }

      }

    }).catch((error) => {

      cards.forEach((card) => {

        renderFlavors(root, card, getFlavors(root));

        setStatus(card, `Inventory could not be checked: ${error.message}`);

      });

    });

  }

  function initAll(scope = document) {

    if (scope.matches?.(ROOT)) initRoot(scope);

    scope.querySelectorAll?.(ROOT).forEach(initRoot);

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());

  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

})();
